import { render } from "./Header2.vue?vue&type=template&id=bfd7ecca&scoped=true"
import script from "./Header2.vue?vue&type=script&lang=js"
export * from "./Header2.vue?vue&type=script&lang=js"

import "./Header2.vue?vue&type=style&index=0&id=bfd7ecca&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd7ecca"]])

export default __exports__